export default {
  text: '#d6941f',
  primary: '#bc351b',
  secondary: '#d6941f',
  background: '#192325',
  backgroundSecondary: '#e3e3db',
  light: '#fdfdfd',
  dark: '#202020'
}
